import React, { Component } from "react";
import { connect } from "react-redux";
import { push, goBack } from "react-router-redux";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import classnames from "classnames";
import _ from "i18n";
import styles from "./CalendarSettings.local.scss";
import ItemMonth from "./ItemMonth";
import {
  setCalendarModifiers,
  setCalendarSelectedDays,
  setCalendarActivatedOption,
  initCalendarSelect,
  setCalendarPlanning,
  setCurrentNavPage,
  setCalendarId,
  initCalendarConfig
} from "Actions";
import {
  saveCalendarSettings,
  fetchCalendarSettings,
  fetchCollaboratorSettingSuggestions
} from "Thunks";
import { MONTHS } from "Config";
import {
  mapAndSortCalendarPlanningByMonth,
  filterDatesTagsByOptions,
  filterDates,
  onSuccess,
  onError
} from "Utils";
import { GarbageIcon } from "../Common/Icons";
import { DIALOG_TYPES, YEARS_VALUES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import clonedeep from "lodash.clonedeep";

import "moment/locale/fr";
import "moment/locale/nl";
import { decryptWithAES } from "../../utils";

const HOLIDAYS_COLOR = "#FF636E";
const WORKING_DAYS_COLOR = "#02AF8E";
const ANNUAL_HOLIDAYS_COLOR = "#F7953E";

class CalendarSettingsPage extends Component {
  constructor(props) {
    super(props);

    const { lng } = this.props;

    const moment = require("moment");
    moment.locale(lng);

    this.state = {
      months: moment.months(),
      yearDivIsVisible: false,
      year: moment().year(),
      zoneDivIsVisible: false,
      zone: null,
      activated: null,
      deleteTagDatesIsVisible: false,
      selectedTagKey: null,
      selectedTagOption: [],
      selectedTagDates: [],
      withoutHeader: false
    };

    this.itemMonthRefs = [];
    MONTHS.forEach(() => {
      this.itemMonthRefs.push(React.createRef());
    });
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );

    document.addEventListener(
      "mousedown",
      this.handleClickOutsideZoneSelect.bind(this)
    );

    const { dispatch, location } = this.props;
    dispatch(setCurrentNavPage("ANNUAL_CALENDAR_SETTING"));

    const params = location.search
      .replace("?params=", "")
      .replace("&params=", "");
    const decryptedParams = decryptWithAES(decodeURIComponent(params));

    const newState = {};

    decryptedParams.split(",").forEach(param => {
      if (param.includes("year")) {
        newState.year = param.split("=")[1];
      }

      if (param.includes("zoneId")) {
        newState.zone = param.split("=")[1];
      }

      if (param.includes("without_header")) {
        newState.withoutHeader = true;
      }
    });

    // Update state once
    this.setState(newState, () => {
      dispatch(initCalendarConfig());
      dispatch(fetchCollaboratorSettingSuggestions());
      dispatch(fetchCalendarSettings(this.state.year, this.state.zone));
    });
  }

  //
  //   *****************   FUNCTIONS  ***********************
  //

  handleRedirectBack = () => {
    const { breadCrumb } = this.props;
    if (breadCrumb.url != null) {
      this.props.dispatch(push(breadCrumb.url));
    } else {
      this.props.dispatch(goBack());
    }
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  setWrapperRefZone(node) {
    this.wrapperRefZone = node;
  }

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleDisplayZoneSelectItems = () => {
    this.setState(state => {
      return {
        zoneDivIsVisible: !state.zoneDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    const { zone } = this.state;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(initCalendarConfig());
    dispatch(fetchCalendarSettings(year, zone.id));
  };

  handleSelectZone = zone => {
    const { dispatch } = this.props;
    const { year } = this.state;

    this.setState({
      zone: zone,
      zoneDivIsVisible: false
    });
    dispatch(initCalendarConfig());
    dispatch(fetchCalendarSettings(year, zone.id));
  };

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  handleClickOutsideZoneSelect(event) {
    if (this.wrapperRefZone && !this.wrapperRefZone.contains(event.target)) {
      this.setState({ zoneDivIsVisible: false });
    }
  }

  handleToggleActivatedMonth = selectedMonth => {
    const { activated } = this.state;
    if (activated == null || activated !== selectedMonth) {
      this.setState({
        activated: selectedMonth
      });
    } else {
      this.setState({
        activated: null
      });
    }
  };

  initCalendarSelect = () => {
    const { dispatch } = this.props;
    dispatch(initCalendarSelect());
  };

  setCalendarSelectedDays = selectedDays => {
    const { dispatch } = this.props;
    dispatch(setCalendarSelectedDays(selectedDays));
  };

  setCalendarActivatedOption = activatedOption => {
    const { dispatch } = this.props;
    dispatch(setCalendarActivatedOption(activatedOption));
  };

  setCalendarModifiers = modifiers => {
    const { dispatch } = this.props;
    dispatch(setCalendarModifiers(modifiers));
  };

  setCalendarPlanning = planning => {
    const { dispatch } = this.props;
    dispatch(setCalendarPlanning(planning));
  };

  setCalendarId = id => {
    const { dispatch } = this.props;
    dispatch(setCalendarId(id));
  };

  saveCalendarSettings = plan => {
    const { dispatch } = this.props;
    const { year, zone } = this.state;

    return dispatch(saveCalendarSettings(plan, year, zone));
  };

  handleDisplayDeleteTagDates = (key, option, item) => {
    let dates = item.map(date => {
      return date.date;
    });

    this.setState({
      selectedTagKey: key,
      selectedTagOption: option,
      selectedTagDates: dates,
      deleteTagDatesIsVisible: true
    });
  };

  cancelDeleteTagDates = () => {
    this.setState({
      selectedTagKey: null,
      selectedTagOption: [],
      selectedTagDates: [],
      deleteTagDatesIsVisible: false
    });
  };

  deleteCalendarTagDatesSetting = () => {
    const { selectedTagOption, selectedTagDates } = this.state;
    const {
      data: { planning },
      modifiers
    } = this.props;

    let month = selectedTagDates[0].getMonth();

    let plan = clonedeep(planning);
    let modif = clonedeep(modifiers);

    plan = filterDatesTagsByOptions(plan, MONTHS[month], selectedTagDates, [
      selectedTagOption
    ]);

    modif[selectedTagOption] = filterDates(
      modif[selectedTagOption],
      selectedTagDates
    );

    this.saveCalendarSettings(plan).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("Calendrier à jour")
        });
        this.setCalendarModifiers(modif);
        this.setCalendarPlanning(plan);
        this.cancelDeleteTagDates();
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleDisplayUpdateTagDates = (label, option, item) => {
    let dates = item.map(date => {
      return date.date;
    });

    let month = dates[0].getMonth();

    this.setState({
      activated: month
    });

    setTimeout(
      this.itemMonthRefs[month].current.setSelectedTagDataToUpdate(
        label,
        option,
        dates
      ),
      2000
    );
  };

  //
  //   *****************   RENDERING  ***********************
  //

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{ marginLeft: 10 }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {YEARS_VALUES.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderZoneSelect = () => {
    const { zoneDivIsVisible, zone } = this.state;

    const { zones } = this.props;

    return (
      <div
        ref={this.setWrapperRefZone.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.zoneDivIsVisible ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{zone && zone.label}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayZoneSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {zoneDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {zones.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectZone(item)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderCalenderStatComponent = (color, number, label) => {
    return (
      <div className={styles.calendar_stats_component}>
        <div className={styles.top_bar} style={{ background: color }} />
        <div className={styles.stat_shape} style={{ background: color }}>
          <span>
            {number} {_("j.")}
          </span>
        </div>
        <span className={styles.label}>{_(label)}</span>
      </div>
    );
  };

  renderMonthsBlocks = () => {
    const {
      lng,
      selectedDays,
      modifiers,
      activatedOption,
      data,
      saving,
      currentNavPage
    } = this.props;

    const { months, year } = this.state;

    return (
      <div className={classnames("row")}>
        {months.map((item, i) => {
          return (
            <div
              key={`month-${i}`}
              className={classnames(
                "columns medium-6 small-12",
                styles.item_div
              )}
            >
              <ItemMonth
                ref={this.itemMonthRefs[i]}
                month={item}
                monthNumber={i}
                lng={lng}
                year={year}
                data={data}
                selectedDays={selectedDays}
                modifiers={modifiers}
                activatedOption={activatedOption}
                setCalendarSelectedDays={this.setCalendarSelectedDays}
                setCalendarModifiers={this.setCalendarModifiers}
                setCalendarActivatedOption={this.setCalendarActivatedOption}
                validateCalendarMonthSetting={this.validateCalendarMonthSetting}
                initCalendarSelect={this.initCalendarSelect}
                setCalendarPlanning={this.setCalendarPlanning}
                setCalendarId={this.setCalendarId}
                handleToggleActivatedMonth={this.handleToggleActivatedMonth}
                active={this.state.activated === i}
                saveCalendarSettings={this.saveCalendarSettings}
                saving={saving}
                currentNavPage={currentNavPage}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderMonthsTags = () => {
    const {
      data: { planning }
    } = this.props;

    const { months } = this.state;

    let plan = planning;

    let monthsRendering = [];
    if (planning) {
      for (let i in MONTHS) {
        let tags = mapAndSortCalendarPlanningByMonth(plan, MONTHS[i], [
          "holidays",
          "annualHolidays",
          "workingDays"
        ]);

        if (tags.length === 0) {
          continue;
        }

        monthsRendering.push(
          <div className={styles.tag_month} key={MONTHS[i]}>
            <span className={styles.tag_month_label}>{months[i]} :</span>
            {this.renderTags(MONTHS[i], tags)}
          </div>
        );
      }
    }

    return monthsRendering;
  };

  renderTags = (month, tags) => {
    let tagsRendering = [];

    tags.forEach((item, i) => {
      tagsRendering.push(
        <div
          className={classnames(
            styles.tag,
            item[0].option === "holidays"
              ? styles.holidays
              : item[0].option === "annualHolidays"
                ? styles.annualHolidays
                : styles.workingDays
          )}
          key={"month_tag_" + i}
        >
          <span className={classnames(styles.tag_color)} />
          <span className={styles.tag_label}>
            {_(
              item[0].label !== "annualHolidays"
                ? item[0].label
                : "Congé fixe - RTT"
            )}{" "}
            :{" "}
            <b>
              {item.map((date, i) => {
                if (i === 0) {
                  return date.date.getDate();
                } else {
                  return " - " + date.date.getDate();
                }
              })}
            </b>
          </span>
          <div
            className={styles.actions_container}
            onClick={event => {
              event.stopPropagation();
            }}
          >
            <div>
              <span
                className={styles.action}
                onClick={() =>
                  this.handleDisplayUpdateTagDates(
                    item[0].label,
                    item[0].option,
                    item
                  )
                }
              >
                <img
                  src={"/img/icons/pencil.svg"}
                  className={styles.back_arrow}
                  alt={""}
                />
              </span>
              <span
                className={styles.action}
                onClick={() =>
                  this.handleDisplayDeleteTagDates(
                    item[0].key,
                    item[0].option,
                    item
                  )
                }
              >
                <img
                  src={"/img/icons/garbage.svg"}
                  className={styles.check_mark}
                  alt={""}
                />
              </span>
            </div>
          </div>
        </div>
      );
    });

    return tagsRendering;
  };

  render() {
    const {
      fetching,
      fetched,
      saving,
      modifiers,
      zonesFetching,
      zonesFetched,
      data,
      zones
    } = this.props;

    const { zone } = this.state;

    if (!zone && zonesFetched && fetched) {
      this.setState({
        zone: fetched && data && data.zone ? data.zone : zones[0]
      });
    }

    return (
      <div className={classnames(styles.calendar_settings, "page-content")}>
        {!this.state.withoutHeader ? (
          <SettingPageHeader
            title={_("calendarSettings")}
            onBack={() => this.handleRedirectBack()}
          />
        ) : null}

        <div className={styles.months_block}>
          <div className={classnames("row")}>
            <div className={classnames("columns medium-8 small-12")}>
              <div className={styles.title_block}>
                <h2 className={styles.title}>{_("calendarSettings")}</h2>
                <h3 className={styles.subtitle}>
                  {_("ManageTheAnnualCalendarOfYourFiduciary")}.
                </h3>

                {/* {zonesFetched && (
                  <div className={styles.filters_container}>
                    {this.renderZoneSelect()}
                    {this.renderYearSelect()}
                  </div>
                )} */}
              </div>

              {(fetching || zonesFetching) && (
                <div className={styles.ripple_loading_adapted}>
                  <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                </div>
              )}
              {fetched && zonesFetched && this.renderMonthsBlocks()}
            </div>
            <div className={classnames("columns medium-4 small-12")}>
              <div className={styles.calendar_stats_container}>
                {/******************      Stats Shape        ******************/}
                <div className={classnames(styles.stats_background)}>
                  <div className={classnames("")} style={{ width: "33.33%" }}>
                    {this.renderCalenderStatComponent(
                      HOLIDAYS_COLOR,
                      modifiers.holidays.length,
                      "holidays"
                    )}
                  </div>
                  <div className={classnames("")} style={{ width: "33.33%" }}>
                    {this.renderCalenderStatComponent(
                      WORKING_DAYS_COLOR,
                      260 +
                        modifiers.workingDays.length -
                        (modifiers.holidays.length +
                          modifiers.annualHolidays.length),
                      "workingDays"
                    )}
                  </div>
                  <div className={classnames("")} style={{ width: "33.33%" }}>
                    {this.renderCalenderStatComponent(
                      ANNUAL_HOLIDAYS_COLOR,
                      modifiers.annualHolidays.length,
                      "Congé fixe - RTT"
                    )}
                  </div>
                </div>
                <div className={styles.stats_background_oval_shape} />

                {/******************      Stats Tags        ******************/}
                <div className={styles.tags_container}>
                  {this.renderMonthsTags()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteTagDatesIsVisible}
          loading={saving}
          TTPDialog={{
            approvedAction: this.deleteCalendarTagDatesSetting,
            abortAction: this.cancelDeleteTagDates,
            message: _("confirmationDeleteCalendarConfigMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  selectedDays: state.calendarSettings.selectedDays,
  modifiers: state.calendarSettings.modifiers,
  activatedOption: state.calendarSettings.activatedOption,
  data: state.calendarSettings.data,
  saving: state.calendarSettings.saving,
  saved: state.calendarSettings.saved,
  fetching: state.calendarSettings.fetching,
  fetched: state.calendarSettings.fetched,
  breadCrumb: state.params.breadCrumb,
  currentNavPage: state.params.currentNavPage,
  zones:
    state.collaborator.settingSuggestions.data &&
    state.collaborator.settingSuggestions.data.zones,
  zonesFetching: state.collaborator.settingSuggestions.fetching,
  zonesFetched: state.collaborator.settingSuggestions.fetched
});

export default connect(mapStateToProps)(CalendarSettingsPage);



// WEBPACK FOOTER //
// ./src/components/CalendarSettings/CalendarSettingsPage.js